module.exports = __webpack_public_path__ + "img/p7.1e867568.png";